import { CIAMConfig } from '../types/index';
import { getEnv } from '../utils/Utils';

const mapEnvFolder = (env: ReturnType<typeof getEnv>): 'dev' | 'prod' => (
  env === 'prod' ? 'prod' : 'dev'
);

const BASE = 'https://tags.tiqcdn.com/utag/usbank/elavon-login';

export const SC_CONFIG = (config: CIAMConfig) => {
  const envFolder = mapEnvFolder(getEnv(config));
  return {
    appId: 'omni',
    src: {
      SC: {
        SYNC_URL: `${BASE}/${envFolder}/utag.sync.js`,
        ASYNC_URL: `${BASE}/${envFolder}/utag.js`,
      },
    },
  };
};
